module.exports = __webpack_public_path__ + "static/img/yixidocumentary.3c46eb7c.png";